import React from 'react';
import { Box, Container, Typography,Link, Card, CardContent } from '@mui/material';
import NavBar from './NavBar';
import Footer from './Footer';

const OurTeam = () => {
  return (
    <Box>
      <NavBar />

      {/* Header Section */}
      <Box sx={{ bgcolor: '#f5f5f5', py: 6, mt: 2 }}>
        <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 'bold',
                    backgroundColor: '#00B140',
                    color: '#fff',
                    marginBottom:'-50px',
                    height: '80px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  Our Team
                </Typography>
      </Box>

      {/* Team Content */}
      <Container maxWidth="md" sx={{ my: 6 }}>
        <Card elevation={3} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              At <strong>PDN & Associates</strong>, our team is composed of highly experienced Chartered Accountants and finance professionals committed to delivering precision, insight, and value to every client we serve. 
              <br /><br />
              Each team member brings a strong foundation of financial expertise and a client-first mindset. Our diverse experiences across industries help us understand your unique needs and deliver solutions that are strategic, compliant, and future-focused.
              <br /><br />
              Whether you're launching a startup, scaling an established company, or looking for personal financial advisory, our team’s collaborative approach ensures that your goals are met with dedication and care.
              <br /><br />
              We take pride in being proactive partners—providing timely advice, regulatory clarity, and customized service that builds long-term trust and growth.
            </Typography>
          </CardContent>
        </Card>

        {/* Why Choose Us */}
        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#001F3F', mb: 2 }}>
              Why Choose PDN & Associates?
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
              When you partner with <strong>PDN & Associates</strong>, you're not just selecting an accounting firm — you're gaining a dedicated ally in your financial journey. Our blend of deep industry knowledge, ethical practice, and cutting-edge compliance expertise helps set your business up for lasting success.
              <br /><br />
              We invite you to experience the difference that comes with working alongside professionals who prioritize your success as their own.
            </Typography>
          </CardContent>
        </Card>
      </Container>
        <Box sx={{ bgcolor: '#eae9e9ff', py: 8 }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            color: '#00B140',
            mb: 1,
            fontFamily: 'Roboto, sans-serif'
          }}
        >
          GET IN TOUCH
        </Typography>

        <Link
          href="mailto:devarajuassociates@gmail.com"
          underline="none"
          sx={{
            color: '#00B140',
            fontWeight: 'bold',
            fontSize: '1.4rem',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          INFO@PDNANDASSOCIATES.COM
        </Link>
      </Container>
    </Box>

      <Footer />
    </Box>
  );
};

export default OurTeam;








